import * as _4 from 'lodash4';
import { Course, CourseRequisite } from '../interfaces/course_requisite_interfaces';
import { ICourseRequisite } from '../interfaces/course_requisite_interfaces';
import { RequisiteNode, RequisiteTree } from './course_requirement_tree';

export class RequisiteServant {
  static getRequisiteTitle(reqNode: RequisiteNode, associatedCourses: Record<string, Course>) {
    if (reqNode.type === 'COURSE' || reqNode.type === 'GRADE') {
      const requisiteCourse = associatedCourses[reqNode.course];
      const rangeText = !!reqNode.range ? `required class grade not met (${reqNode.range})` : '';
      if (requisiteCourse) {
        // TODO: Check with Sravan for this
        // reqNode._course = requisiteCourse;
        reqNode.title = `<span class="text text-sz-s">${requisiteCourse.cd} ${requisiteCourse.title} ${rangeText}</span> `;
      }
    }
    if (RequisiteServant.isTestTypeRequisite(reqNode)) {
      const range = !!reqNode.range ? `(${reqNode.range})` : '';
      const displayTitle = !_4.isNil(reqNode.title) ? reqNode.title : reqNode.test;
      reqNode.title = `<span class="text text-sz-s">${displayTitle} ${range}</span>`;
    }
    return reqNode.title;
  }

  static isTestTypeRequisite(reqNode: RequisiteNode) {
    return reqNode.type === 'TEST';
  }

  static formChildrenReqList(reqNode: RequisiteNode, associatedCourses: Record<string, Course>) {
    const nonCompactedReqList = reqNode.childrens.map((child) =>
      RequisiteServant.formRequisiteList(child, associatedCourses)
    );
    return _4.compact(nonCompactedReqList);
  }

  static formRequisiteList(reqNode: RequisiteNode, associatedCourses: Record<string, Course>): string {
    if (_4.isEmpty(reqNode.childrens)) {
      const title = RequisiteServant.getRequisiteTitle(reqNode, associatedCourses);
      if (_4.isEmpty(title)) {
        return ``;
      }
      return `<hi-leaf class="text text-sz-m pbsx">${title}</hi-leaf>`;
    } else {
      const reqList = RequisiteServant.formChildrenReqList(reqNode, associatedCourses);
      const hasOneEntry = reqList.length === 1;
      if (hasOneEntry) {
        return `<hi-leaf class="text text-sz-m pbsx">${reqList.join(' ')}</hi-leaf>`;
      }

      return `
          <hi-sub-tree heading="${RequisiteServant.getRequisiteTitle(reqNode, associatedCourses)}">
            ${reqList.join(' ')}
          </hi-sub-tree>`;
    }
  }

  static getRequisiteTree(
    _requisites: Record<string, ICourseRequisite> | ICourseRequisite[],
    associatedCourses: Record<string, Course>
  ) {
    const requisites = _4.toArray(_requisites);
    const reqTree = new RequisiteTree();
    reqTree.insert(requisites[0]);

    let lastNode = reqTree.root;
    requisites.slice(1).forEach((req: RequisiteNode) => {
      lastNode = reqTree.insertData(req, lastNode as RequisiteNode);
      return lastNode;
    });

    return `
      <hi-tree>
        ${RequisiteServant.formRequisiteList(reqTree.root as RequisiteNode, associatedCourses)}
      </hi-tree>
      `;
  }

  static openFirstLadderOfTree(tree: string) {
    const subTreeTagName = 'hi-sub-tree';
    const firstLadder = tree.search(subTreeTagName);
    const firstIndex = 0;
    if (firstLadder < firstIndex) {
      return tree;
    }
    const indexAfterSubtree = firstLadder + subTreeTagName.length;
    const untilSubTreeNodeText = tree.slice(firstIndex, indexAfterSubtree);
    const afterSubTreeNodeText = tree.slice(indexAfterSubtree);
    return untilSubTreeNodeText + ` add-attr="{'timeout': 500, 'attribute': 'opened'}" ` + afterSubTreeNodeText;
  }

  static getRequisiteHtml(
    requisites: Record<string, ICourseRequisite> | ICourseRequisite[],
    associatedCourses: Record<string, Course>
  ) {
    const reqTree = RequisiteServant.getRequisiteTree(requisites, associatedCourses);
    return RequisiteServant.openFirstLadderOfTree(reqTree);
  }

  static getPreRequisiteIssueText() {
    return `Please make sure that all prerequisite courses meet the grade requirements before taking this course.`;
  }

  static hasTestPreRequisite(preReqs: CourseRequisite): boolean {
    return _4.some(preReqs, (req: ICourseRequisite) => req.type === 'TEST');
  }

  static hasPreRequisiteIssues(preReqs: CourseRequisite): boolean {
    return _4.some(preReqs, (req: ICourseRequisite) => req.is_grade_satisfied !== null && !req.is_grade_satisfied);
  }

  static getPreRequisiteTestIssueText(advisorTitle: string = 'advisor') {
    return `Passing test score may also satisfy the prerequisite(s) for this course. 
    Please see your ${advisorTitle} for details on testing and score requirements.`;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/biz-ng-requisite-tree/src/servants/course_requirement_servant.ts